"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTestId = exports.checkForInvalidColor = exports.getBarPercentage = exports.getPercentage = exports.segmentColor = exports.validSegmentColors = exports.barSpec = exports.ellipsisStyle = exports.fullWidthFlexStyle = exports.columnFlexStyle = exports.rowFlexStyle = void 0;
var css_1 = require("@emotion/css");
exports.rowFlexStyle = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
exports.columnFlexStyle = (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
exports.fullWidthFlexStyle = (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n"], ["\n  display: flex;\n  width: 100%;\n"])));
exports.ellipsisStyle = (0, css_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
exports.barSpec = {
    sm: {
        height: 12,
        radius: 2,
        sideLabelSeparatorWidth: 12,
        labelFont: 'metadata',
        footerLabelPadding: 0,
        minSegmentWidth: 8,
    },
    lg: {
        height: 24,
        radius: 4,
        sideLabelSeparatorWidth: 12,
        labelFont: 'bodyStrong',
        footerLabelPadding: 4,
        minSegmentWidth: 16,
    },
};
exports.validSegmentColors = [
    'white',
    'turquoise70',
    'green50',
    'green30',
    'yellow50',
    'orange50',
    'red50',
    'neutral30',
    'neutral40',
    'neutral60',
    'neutral90',
    'darkTheme.black',
    'darkTheme.white',
    'darkTheme.teal100',
    'darkTheme.blueGray50',
    'darkTheme.blueGray100',
    'darkTheme.red100',
    'darkTheme.orange',
    'darkTheme.yellow',
    'darkTheme.green100',
    'darkTheme.purple100',
    'darkTheme.blue100',
];
exports.segmentColor = {
    red50: {
        fillColor: 'red50',
        borderColor: 'red90',
    },
    orange50: {
        fillColor: 'orange50',
        borderColor: 'orange90',
    },
    yellow50: {
        fillColor: 'yellow50',
        borderColor: 'yellow90',
    },
    green30: {
        fillColor: 'green30',
        borderColor: 'green70',
    },
    green50: {
        fillColor: 'green50',
        borderColor: 'green90',
    },
    turquoise70: {
        fillColor: 'turquoise70',
        borderColor: 'turquoise90',
    },
    white: {
        fillColor: 'white',
        borderColor: 'neutral60',
    },
    neutral30: {
        fillColor: 'neutral30',
        borderColor: 'neutral30',
    },
    neutral40: {
        fillColor: 'neutral40',
        borderColor: 'neutral60',
    },
    neutral60: {
        fillColor: 'neutral60',
        borderColor: 'neutral80',
    },
    neutral90: {
        fillColor: 'neutral90',
        borderColor: 'neutral90',
    },
    'darkTheme.black': {
        fillColor: 'darkTheme.black',
        borderColor: 'darkTheme.blueGray50',
    },
    'darkTheme.white': {
        fillColor: 'darkTheme.white',
        borderColor: 'darkTheme.dimWhite',
    },
    'darkTheme.green100': {
        fillColor: 'darkTheme.green100',
        borderColor: 'darkTheme.dimGreen',
    },
    'darkTheme.purple100': {
        fillColor: 'darkTheme.purple100',
        borderColor: 'darkTheme.dimPurple',
    },
    'darkTheme.blue100': {
        fillColor: 'darkTheme.blue100',
        borderColor: 'darkTheme.dimBlue',
    },
    'darkTheme.blueGray100': {
        fillColor: 'darkTheme.blueGray100',
        borderColor: 'darkTheme.blueGray50',
    },
    'darkTheme.blueGray50': {
        fillColor: 'darkTheme.blueGray50',
        borderColor: 'darkTheme.dimBlueGray',
    },
    'darkTheme.teal100': {
        fillColor: 'darkTheme.teal100',
        borderColor: 'darkTheme.dimTeal',
    },
    'darkTheme.red100': {
        fillColor: 'darkTheme.red100',
        borderColor: 'darkTheme.dimRed',
    },
    'darkTheme.orange': {
        fillColor: 'darkTheme.orange',
        borderColor: 'darkTheme.dimOrange',
    },
    'darkTheme.yellow': {
        fillColor: 'darkTheme.yellow',
        borderColor: 'darkTheme.dimYellow',
    },
};
var getPercentage = function (partialValue, totalValue) {
    return (partialValue / totalValue) * 100;
};
exports.getPercentage = getPercentage;
var getBarPercentage = function (partialValue, totalValue) {
    var percentage = (0, exports.getPercentage)(partialValue, totalValue);
    return percentage < 10 ? 10 : percentage;
};
exports.getBarPercentage = getBarPercentage;
var checkForInvalidColor = function (color) {
    if (!exports.validSegmentColors.includes(color)) {
        throw new Error("Invalid segment color, valid colors are [".concat(exports.validSegmentColors, "] and you passed in [").concat(color, "]."));
    }
};
exports.checkForInvalidColor = checkForInvalidColor;
var getTestId = function (suffix, testId) {
    return testId && "".concat(testId, "-").concat(suffix);
};
exports.getTestId = getTestId;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
